import React from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { PhoneIphone } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { trackEventMatomo } from 'js/library/utils/helpers';

export const Footer = () => {
  const { t } = useTranslation();

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  let url = '';
  const androidUrl = 'https://triibo.page.link/1c84';
  const iosUrl = 'https://triibo.page.link/TWAF';

  if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
    url = iosUrl;
  } else {
    url = androidUrl;
  }

  return (
    <div className="footer-container">
      <div className="container">
        <Grid container>
          <Grid size={{ md: 8, sm: 8, xs: 8 }} style={{ display: 'flex', alignItems: 'center' }}>
            <a
              onClick={() => trackEventMatomo('Home', 'tocar', 'botao', 'Políticas de privacidade')}
              style={{ textDecoration: 'none' }}
              href={document.location.origin + '/termos-de-uso-dos-servicos-triibo/'}
              target="new"
            >
              <Typography variant="body2" color="secondary" display="inline">
                {t('home.privacy_policies')}
              </Typography>
            </a>
          </Grid>
          <Grid size={{ md: 4, sm: 4, xs: 4 }}>
            <a
              onClick={() =>
                trackEventMatomo('Home', 'tocar', 'botao', 'Baixe grátis o app da Triibo!')
              }
              href={url}
              target="new"
              style={{ textDecoration: 'none' }}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                className="footer-button"
                style={{ textTransform: 'none', lineHeight: '1.2' }}
              >
                <PhoneIphone />
                {t('home.app_free_download')}
              </Button>
            </a>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Footer;
